// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_core__HttpClient from "./HttpClient.js";
import * as Buhta_models__Atd from "../../models/Atd.js";
import * as Buhta_models__Protocol_v1_bs from "../../models/generated/Protocol_v1_bs.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../vendored/promise/promise.js";
import * as Stdlib from "melange/stdlib.js";
import * as React from "react";

function decodeErrorResponse(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_v1_bs.read_error_response, param);
}

function defaultResponseHandler(decode, errorDecode, resp) {
  const errorDecode$1 = Belt__Belt_Option.getWithDefault(errorDecode, decodeErrorResponse);
  return resp.json().then(function (json) {
                if (resp.ok) {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: Curry._1(decode, json)
                            });
                }
                let error;
                try {
                  error = Curry._1(errorDecode$1, json);
                }
                catch (raw_exn){
                  const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                  console.log("req exn", exn);
                  return Promise.reject(exn);
                }
                console.log("req error", error);
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: error.error
                          });
              }).catch(function (err) {
              console.log("response parse error", err);
              return Promise.resolve({
                          TAG: /* Error */1,
                          _0: {
                            code: 500,
                            request: undefined,
                            message: "Unexpected error",
                            data: undefined
                          }
                        });
            });
}

function convertJsResultPromise(jsPromise) {
  const rejectable = $$Promise.Js.fromBsPromise(jsPromise);
  const __x = $$Promise.Js.toResult(rejectable);
  return $$Promise.flatMap(__x, (function (res) {
                if (res.TAG === /* Ok */0) {
                  return $$Promise.resolved(res._0);
                } else {
                  return $$Promise.resolved({
                              TAG: /* Error */1,
                              _0: {
                                code: 500,
                                request: undefined,
                                message: "Unexpected error",
                                data: undefined
                              }
                            });
                }
              }));
}

function get(headers, decode, errorDecode, url) {
  return convertJsResultPromise(Buhta_core__HttpClient.get(headers, url).then(function (param) {
                  return defaultResponseHandler(decode, errorDecode, param);
                }));
}

function post(headers, errorDecode, decode, url, payload) {
  return convertJsResultPromise(Buhta_core__HttpClient.post(headers, url, payload).then(function (param) {
                  return defaultResponseHandler(decode, errorDecode, param);
                }));
}

function put(headers, errorDecode, decode, url, payload) {
  return convertJsResultPromise(Buhta_core__HttpClient.put(headers, url, payload).then(function (param) {
                  return defaultResponseHandler(decode, errorDecode, param);
                }));
}

function useFetch(url, decode, param) {
  const match = React.useReducer((function (_state, action) {
          if (typeof action === "string") {
            return "Loading";
          } else if (action.NAME === "Failed") {
            return {
                    NAME: "Error",
                    VAL: action.VAL
                  };
          } else {
            return {
                    NAME: "Data",
                    VAL: action.VAL
                  };
          }
        }), "Loading");
  const dispatch = match[1];
  const state = match[0];
  React.useEffect((function () {
          Curry._1(dispatch, "Fetch");
        }), [url]);
  React.useEffect((function () {
          if (state === "Loading") {
            const __x = get(undefined, decode, undefined, url);
            $$Promise.map(__x, (function (result) {
                    if (result.TAG === /* Ok */0) {
                      return Curry._1(dispatch, {
                                  NAME: "Fetched",
                                  VAL: result._0
                                });
                    } else {
                      return Curry._1(dispatch, {
                                  NAME: "Failed",
                                  VAL: result._0
                                });
                    }
                  }));
          }
          
        }), [state]);
  return state;
}

function useUrlFilters(filters) {
  const match = React.useState(function () {
        return filters;
      });
  const setFilters = match[1];
  const filters$1 = match[0];
  React.useEffect((function () {
          Curry._1(setFilters, (function (param) {
                  return filters$1;
                }));
        }), [filters$1]);
  const updateFilter = function (name, value) {
    const filtersPopedName = Belt__Belt_List.keep(filters$1, (function (param) {
            return Caml_obj.caml_notequal(param[0], name);
          }));
    Curry._1(setFilters, (function (param) {
            return Stdlib.$at(filtersPopedName, {
                        hd: [
                          name,
                          value
                        ],
                        tl: /* [] */0
                      });
          }));
  };
  return [
          filters$1,
          updateFilter
        ];
}

function useFilters(param, param$1) {
  const value2 = param$1[1];
  const name2 = param$1[0];
  const value1 = param[1];
  const name1 = param[0];
  const fieldsToFilterList = function (param) {
    const __x_0 = [
      name1,
      value1
    ];
    const __x_1 = {
      hd: [
        name2,
        value2
      ],
      tl: /* [] */0
    };
    const __x = {
      hd: __x_0,
      tl: __x_1
    };
    return Belt__Belt_List.keepMap(__x, (function (param) {
                  const name = param[0];
                  return Belt__Belt_Option.map(param[1], (function (value) {
                                return [
                                        name,
                                        value
                                      ];
                              }));
                }));
  };
  const match = React.useState(function () {
        return fieldsToFilterList(undefined);
      });
  const setFilters = match[1];
  React.useEffect((function () {
          Curry._1(setFilters, (function (param) {
                  return fieldsToFilterList(undefined);
                }));
        }), [
        value1,
        value2
      ]);
  return [
          match[0],
          setFilters
        ];
}

function useFilters2(param, param$1) {
  const value2 = param$1[1];
  const name2 = param$1[0];
  const value1 = param[1];
  const name1 = param[0];
  const justInitialized = React.useRef(true);
  const fieldsToFilterList = function (param) {
    const __x_0 = [
      name1,
      value1
    ];
    const __x_1 = {
      hd: [
        name2,
        value2
      ],
      tl: /* [] */0
    };
    const __x = {
      hd: __x_0,
      tl: __x_1
    };
    return Belt__Belt_List.keepMap(__x, (function (param) {
                  const name = param[0];
                  return Belt__Belt_Option.map(param[1], (function (value) {
                                return [
                                        name,
                                        value
                                      ];
                              }));
                }));
  };
  const match = React.useState(function () {
        return fieldsToFilterList(undefined);
      });
  const setFilters = match[1];
  React.useEffect((function () {
          if (!justInitialized.current) {
            Curry._1(setFilters, (function (param) {
                    return fieldsToFilterList(undefined);
                  }));
          }
          justInitialized.current = false;
        }), [
        value1,
        value2
      ]);
  return [
          match[0],
          setFilters
        ];
}

export {
  decodeErrorResponse ,
  defaultResponseHandler ,
  convertJsResultPromise ,
  get ,
  post ,
  put ,
  useFetch ,
  useUrlFilters ,
  useFilters ,
  useFilters2 ,
}
/* Buhta_core__HttpClient Not a pure module */
